import { onBoardURL } from "../config";

export const loginAndStoreToken = async (email, password, backendUrl) => {
  try {
    const response = await fetch(backendUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Network response was not ok');
    }

    const data = await response.json();
    const { token, user } = data;

    // Store in localStorage
    localStorage.setItem("auth", JSON.stringify(data));
    localStorage.setItem("token", token);

    // Return full data so caller can inspect user.roleId
    return data;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
};
  
  // Login authentication logic  ended
  
  // logout logic 
  export const logout = () => {
    localStorage.setItem("token", "");
    localStorage.setItem("auth", "");

  }
  
  // logout logic  ended

  // start onboard 

  export const onboardUser = async (data) => {
    try {
      const response = await fetch(onBoardURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      const res = await response.json();
  
      if (!response.ok) {
        throw new Error(res.message || 'Network response was not ok');
      }
  
      return res;
    } catch (e) {
      console.error('Onboarding failed:', e);
      throw new Error(e.message || 'Failed to onboard user');
    }
  };
  